var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowStepDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 29,
    viewBox: "0 0 7 29",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.371 0.021 C 3.195 0.067,3.058 0.207,3.017 0.385 C 3.001 0.453,2.999 1.847,2.999 13.555 L 2.998 26.649 1.909 25.377 C 1.086 24.418,0.803 24.095,0.751 24.058 C 0.616 23.961,0.475 23.950,0.321 24.026 C 0.219 24.077,0.083 24.199,0.034 24.283 C 0.001 24.340,0.000 24.348,0.000 24.494 C 0.000 24.642,0.001 24.647,0.036 24.708 C 0.085 24.794,2.994 28.185,3.070 28.245 C 3.199 28.347,3.327 28.391,3.500 28.391 C 3.673 28.391,3.801 28.347,3.930 28.245 C 4.006 28.185,6.915 24.794,6.964 24.708 C 6.999 24.647,7.000 24.642,7.000 24.494 C 7.000 24.348,6.999 24.340,6.966 24.283 C 6.917 24.199,6.781 24.077,6.679 24.026 C 6.525 23.950,6.384 23.961,6.249 24.058 C 6.197 24.095,5.914 24.418,5.091 25.377 L 4.002 26.649 4.002 13.557 C 4.002 1.705,4.000 0.458,3.983 0.385 C 3.942 0.205,3.798 0.061,3.617 0.018 C 3.521 -0.004,3.467 -0.004,3.371 0.021 ",
    stroke: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowStepDown);
export default __webpack_public_path__ + "static/media/arrow-step-down.7496253721ef8024c92788a109a178bb.svg";
export { ForwardRef as ReactComponent };